import {SWIPER_ARGS_VIEW} from "Includes/config";

export default class Lightbox {

    static class_name = 'wpbs-lightbox';

    static swiper_args = (index = 0) => ({
        ...SWIPER_ARGS_VIEW,
        initialSlide: index,
        spaceBetween: 10,
        slidesPerView: 1,
        simulateTouch: true,
        zoom: {
            toggle: true,
            limitToOriginalSize: true,
            maxRatio: 8,
            containerClass: 'swiper-zoom-container',
        },
    });

    /**
     * Always loads the latest Swiper from CDN if not already present.
     */
    static async loadSwiper() {
        if (window.Swiper) return window.Swiper;
        if (window.wpbsSwiperLoading) return window.wpbsSwiperLoading;

        window.wpbsSwiperLoading = new Promise((resolve, reject) => {
            // Check for any existing swiper link to avoid duplicates
            if (!document.querySelector('link[href*="swiper"]')) {
                const link = document.createElement('link');
                link.rel = 'stylesheet';
                // Omitting @version gets the latest
                link.href = 'https://cdn.jsdelivr.net/npm/swiper/swiper-bundle.min.css';
                document.head.appendChild(link);
            }

            const script = document.createElement('script');
            script.src = 'https://cdn.jsdelivr.net/npm/swiper/swiper-bundle.min.js';
            script.async = true;
            script.onload = () => resolve(window.Swiper);
            script.onerror = () => reject(new Error("WPBS Lightbox: Failed to load latest Swiper."));
            document.head.appendChild(script);
        });

        return window.wpbsSwiperLoading;
    }

    static init() {
        document.addEventListener('click', (event) => {

            const isLightbox = event.target.closest(`.${this.class_name}`);
            const element = event.target.closest('.--lightbox');
            if (isLightbox !== null || element === null) return;

            const wrapper = element.closest('[data-lightbox]');
            if (!wrapper) return;

            const indexed = element.closest('.--lightbox[data-index]') || wrapper;

            const raw = wrapper.getAttribute('data-lightbox');
            if (!raw) return;

            let payload;
            try {
                payload = JSON.parse(raw);
            } catch (e) {
                console.error('WPBS Lightbox: invalid JSON', e);
                return;
            }

            const media = Array.isArray(payload?.media) ? payload.media : [];
            if (!media.length) return;

            this.toggle({
                index: Number.parseInt(indexed?.dataset?.index ?? 0, 10) || 0,
                media,
                settings: payload.settings || {},
            });
        }, {
            passive: true,
        });
    }

    static async toggle(args = {}) {
        const endpoint = '/wp-json/wpbs/v1/media-gallery/lightbox';

        try {
            // Parallel load: Assets + API Data
            const [swiper, response] = await Promise.all([
                this.loadSwiper(),
                fetch(endpoint, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-WP-Nonce': WPBS?.settings?.nonce ?? '',
                    },
                    body: JSON.stringify({
                        postId: args.settings?.gallery_id,
                        media: args.media,
                        index: args.index ?? 0,
                        settings: args.settings ?? {},
                    }),
                })
            ]);

            if (!response.ok) throw new Error('Network response error');

            const result = await response.json();
            const parser = new DOMParser();
            const lightbox_element = parser
                .parseFromString(result?.rendered ?? '', 'text/html')
                .querySelector(`.${this.class_name}`);

            if (!lightbox_element) return;

            WPBS.modals.show_modal(false, {
                template: lightbox_element,
                callback: (modal) => {
                    WPBS.slider.observe(
                        modal.querySelector('.swiper'),
                        this.swiper_args(args.index ?? 0)
                    );

                    if (window.MediaWatcher) window.MediaWatcher.init(modal);
                },
            });

        } catch (error) {
            console.error('WPBS Lightbox Error:', error);
        }
    }
}